module.exports = __webpack_public_path__ + "img/newempty-chatdark.1dd12b25.svg";